/**
自定义菜单操作类
ver 2.0.0
修改记录：
  2018-7-10：

  菜单配置模板：

  type：支持类型：
    router  :vue路由
    confirm ：确认请求操作
    moreButton :更多菜单
    component: 组件
     submit ：直接执行请求操作
     method ：调用当前页面方法
     saveFormData：保存草稿（不做验证）
     submitFormData ：提交from表单，做校验
     handleSubmitFormDataBefore: 提交form表单前置钩子
     deleteSubmit :删除提交。
     unApproveSubmit :弃审提交。
     cancelSubmit :撤销提交。
     exportOfCondition:基于高级查询结构导出
    requerst :无弹窗提交请求
    openWindow :新开窗口

         {
               "type":"exportOfCondition",
                 "cssType":"warning",
               "icon":"trash-b",
               "name":"导出",
               "param":{
                   "criteriaCode":""ISCC_ORDER_TEMPLATE_ALLOCATION_QUERY"",
                   "tableCode":""

               },
             "requestParam":{
               "method":"post",
               "url":"rest/main/system/system/exportOfCondition"
             }

    }，
  {
      "type":"router",
      "icon":"edit",
      "cssType":"",
      "name":"编辑",
      "param":{
          "path":"",
          "name":"pangu-crud-edit"
      },
      "requestParam":{"id":"{{data.id}}","userId":"{{user.id}}"}

  },{
        "type":"confirm",
          "cssType":"warning",
        "icon":"trash-b",
        "name":"删除",
        "param":{
            "title":"删除",
            "content":"<p>确定要删除</p>",
            "method":"post",
            "url":"rest/main/system/system/remove"
        },
      "requestParam":{"id":"{{data.id}}","userId":"{{user.id}}"}

    },

    {
          "type":"component",
            "cssType":"warning",
          "icon":"trash-b",
          "name":"删除",
          "param":{
              "component":"selectOfModalTable",

          },
        "requestParam":{
         "content":"<p>确定要删除</p>",
          "method":"post",
          "url":"rest/main/system/system/remove"
        }

      }

*/
import objectUtil from './objectUtil'
import templateUtil from './templateUtil'
import cacheRequest from './cacheRequest'
import urlUitls from './urlUitls'
import { routerSystem } from './systemUtil'

import Vue from 'vue'
var menuUtils = {}

// 定义特殊处理方法
menuUtils.special = {}

const getValue = objectUtil.getValueByPath

// 销毁组件
let InstanceDaed = function (dom) {
  if (dom) {
    // 后置动作是打开新窗口的时候，报错保护 fpr
    if (dom.$options) {
      dom.$destroy?.()
    }
    if (dom.$el) {
      dom.$el.parentNode?.removeChild?.(dom.$el)
    }

    for (var key in dom) {
      delete dom[key]
    }
    dom = null
    console.info('menuUtils.typeMethod.component  $destroy')
  }
}

/**
 * @name: 强制提交请求
 * @test: test font
 * @msg:
 * @param {vue}
 * @param {menuParameter} 按钮配置参数
 * @param {data} 进行模板编译的数据
 * @param {res} 接口返回数据
 * @param {form} 是否是整单提交
 * @return:
 */
menuUtils.special.forceSubmit = function (
  vue,
  menuParameter,
  data,
  res,
  form,
  callback,
  errorCallback
) {
  return new Promise((resolve, reject) => {
    let ifJde = false
    if (res && res.data.errors && res.data.errors.length > 0) {
      let errorArr = res.data.errors
      for (let i = 0; i < errorArr.length; i++) {
        if (errorArr[i] && errorArr[i].rule == 'JDE收货地址校验') {
          // JDE收货地址校验时将查看问题改为补充地址
          ifJde = true
        }
        if (errorArr[i].level == 1) {
          vue.$pgMessage.confirm({
            title: '提示',
            content: res.data.msg,
            onOk: () => {
              vue.$nextTick(() => {
                reject(res)
              })
            },
            cancel: () => {
              reject(res)
            },
          })
          return
        }
      }
      let tempData = JSON.stringify(data)
      tempData = JSON.parse(tempData)
      let temMenuParameter = JSON.parse(JSON.stringify(menuParameter))

      //记住初始数据用于设置加载中动画
      if (temMenuParameter._oldParameter) {
        temMenuParameter._oldParameter = menuParameter._oldParameter
      } else {
        temMenuParameter._oldParameter = menuParameter
      }
      if (!temMenuParameter.param) temMenuParameter.param = {}
      if (!temMenuParameter.param.forceConfim) temMenuParameter.param.forceConfim = {}
      temMenuParameter.param.forceSubmit = true
      temMenuParameter.param.forceConfim.content =
        temMenuParameter.param.forceConfim.content || res.data.msg
      temMenuParameter.param.forceConfim.showCancelBtn =
        temMenuParameter.param.forceConfim.hasOwnProperty('showCancelBtn')
          ? temMenuParameter.param.forceConfim.showCancelBtn
          : true
      temMenuParameter.param.forceConfim.cancelBtnText = ifJde ? '补充地址' : '查看问题'
      temMenuParameter.param.forceConfim.sureBtnText =
        temMenuParameter.param.forceConfim.sureBtnText || '继续提交'
      if (form) {
        tempData.data.forceSubmit = true
        menuUtils.typeMethod
          .submitFormData(vue, temMenuParameter, tempData, callback, errorCallback)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            //error无值表示弹窗点击取消或查看问题等没有调用接口的情况，直接返回上次结果
            reject(error ? error : res)
          })
      } else {
        if (!temMenuParameter.requestParam) temMenuParameter.requestParam = {}
        temMenuParameter.requestParam.forceSubmit = true
        menuUtils.typeMethod
          .submit(vue, temMenuParameter, tempData, callback, errorCallback)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            //error无值表示弹窗点击取消或查看问题等没有调用接口的情况，直接返回上次结果
            reject(error ? error : res)
          })
      }
    } else {
      vue.$cfn.ajax1.isOK(res, vue)
      reject(res)
    }
  })
}

/**
 * @name:
 * @test: test font
 * @msg: 只用于code为200时调用判断提示是使用$pgMessage.confirm还是$Message.success
 * @param {type}
 * @return:
 */
menuUtils.special.tipFn = function (vue, data, param, commonData) {
  if (data.errors && data.errors.length > 0) {
    if (param && param.showToast) {
      if (data.errors.some((im) => im.level === 1)) {
        vue.$Message.error(data.msg)
      } else if (data.errors.some((im) => im.level === 3)) {
        vue.$Message.warning(data.msg)
      } else {
        vue.$Message.success(data.msg)
      }
    } else {
      vue.$pgMessage.confirm({
        title: '提示',
        content: data.msg,
      })
    }
  } else {
    if (param && param.showToast) {
      if (param.showToast === 'showAlert') {
        // 增加静态参数配置showToast = 'showAlert',请求成功后，将会以弹窗的形式提示信息
        /*
         * routerInfo：{name：路由名称，function，id：单据id}
         */
        if (param.routerInfo) {
          // Object.assign({},commonData, data.data) 此处只做数据传递
          // {data:[{code: 'xxxx', id:'xxxxx', bizCode:'xxxx'}],msg:'xxx',.....}
          let routerInfo = {
            commonData: commonData, // 包括全局参数
            param: param.routerInfo, // 传入的静态参数
            data: data.data, // 后台返回的data
          }
          vue.$pgMessage.confirm({
            title: '提示',
            routerInfo: routerInfo,
            parentVue: vue,
          })
        } else {
          vue.$pgMessage.confirm({
            title: '提示',
            content: data.msg,
          })
        }
      } else {
        vue.$Message.success(data.msg)
      }
    } else if (!param || param.showToast !== false) {
      vue.$Message.success(data.msg)
    }
  }
}

/**
 * @name: 进度条
 * @test:
 * @msg:
 * @param {vue}
 * @param {progreessTask}
 * textTemplate  成功结果模板
 * resultTemplate  是否使用后台返回模板默认为false，为true时textTemplate不生效
 * @return:
 */
menuUtils.special.progressTask = function (vue, progressTask, param) {
  let promise = null
  if (param.nowExecute) {
    let { urlProgress = '/rest/main/progressTask/getAndClearCompleteCache', hideConfirm } = param
    let data = { id: progressTask.id }
    promise = new Promise((resolve, reject) => {
      const getProgress = (urlProgress, data) => {
        vue.$axios
          .get(urlProgress, { params: data })
          .then((res) => {
            if (!vue.$cfn.ajax1.isOK(res, vue)) return
            const _data = res.data.data
            const statusCode = _data.status.code
            if (statusCode === 'WAIT' || statusCode === 'DOING') {
              setTimeout(() => {
                getProgress(urlProgress, { id: _data.id })
              }, 1000)
            } else {
              if (!hideConfirm && _data.message)
                vue.$pgMessage.confirm({
                  title: '提示',
                  content: _data.message,
                })
              resolve(res)
            }
          })
          .catch((err) => {
            vue.$cfn.ajax1.catch1(err, vue)
            reject(err)
          })
      }
      getProgress(urlProgress, data)
    })
  } else {
    promise = new Promise((resolve, reject) => {
      vue.$pgMessage.progressTask({
        ifSureClose: true,
        loadingText: param.loadingText || '加载中...',
        resultTemplate: param.resultTemplate !== undefined ? param.resultTemplate : false,
        textTemplate: param.textTemplate || '更新完毕！本次更新成功$success$条, 失败$fail$',
        title: param.progressTaskTitle,
        leftText: param.leftText,
        routerObj: param.routerObj,
        data: progressTask,
        sureClose: (flag, res) => {
          if (flag) {
            resolve(res)
          } else {
            reject(res)
          }
        },
      })
    })
  }
  return promise
}

/**
 * 调用方法之前判断是都需要弹窗确认提示
 * [vue]
 * [param]  参数对象
 * [defaultVal] 控制默认是否弹窗，为true时默认弹确认提示框，为false时默认不弹出确认提示框,在强制提交时一定弹窗
 */
menuUtils.special.ifConfirm = function (vue, param, defaultVal = true) {
  return new Promise((resolve, reject) => {
    let ifForce = param.forceSubmit //是否是强制提交
    let isConfirm = ifForce ? true : defaultVal ? !param.ifConfirm : param.ifConfirm
    if (isConfirm) {
      const confim = ifForce ? param.forceConfim : param
      vue.$pgMessage.confirm({
        title: confim.title || '确认',
        content: confim.content || '确认提交？',
        sureBtnText: confim.sureBtnText || '确认',
        showCancelBtn: confim.showCancelBtn ?? (confim.showSureBtnRight ? false : true),
        cancelBtnText: confim.cancelBtnText ?? '取消',
        cancelBtnType: confim.cancelBtnType,
        cancelBtnPlain: confim.cancelBtnPlain || false,
        showSureBtnRight: confim.showSureBtnRight || false,
        sureBtnTextRight: confim.sureBtnTextRight || '保存并继续',
        onOk: () => {
          resolve()
        },
        onOkRight: (dead) => {
          if (dead) dead()
          resolve('RIGHT')
        },
        cancel: () => {
          reject()
        },
      })
    } else {
      resolve()
    }
  })
}

// 定义支持动作有哪些。
menuUtils.typeMethod = {}

/**
 * @name: 请求类的处理方法
 * @test: test font
 * @msg: 【{
 * param:{
 *      url: String,//必填，请求接口url
 *      method: String,//请求接口方式
 *      showToast: Boolean || String,//当接口返回code!==200&&code!==400时的提示方式，默认为弹窗提示, 有值时为showToast；当code==200时，默认是showToast,有值时为弹窗
 *      routerInfo：{name：路由名称，function，id：单据id}//支持
 *      submit: Boolean,//是否提交整单数据，默认false，不提交整单数据
 *      updateData: Boolean,//为true时当请求返回code == 400 时更新表单数据
 *      ifConfirm: Boolean,//请求接口前是否弹窗提示，默认false；由于历史原因默认是否弹窗根据调用时的defaultIfConfirm参数控制；defaultIfConfirm==true时默认弹窗 ===false时默认不弹窗
 *  }
 * }】
 * @param {vue} vue实例
 * @param {data} 进行模板编译的数据
 * @param {menuParameter} 按钮配置参数
 * @param {method} 如果menuParameter中未配置请求方式时，调用时传入的method用作默认请求方式
 * @param {form} 是否提交整个表单，作为param.submit的缺省值,默认为false;如果提交整个表单则会将动态参数放入整单的optional字段中
 * @param {defaultIfConfirm} 控制ifConfirm字段默认是否弹窗，为true时默认弹确认提示框，为false时默认不弹出确认提示框
 * @param {errorNex} 为true时当请求报错时弹窗提示，点击确定后执行后续动作，为false时直接提示
 * @return:
 */
menuUtils.typeMethod.requerstData = async function (
  vue,
  menuParameter,
  data,
  callback,
  errorCallback,
  method = 'post',
  form = false,
  defaultIfConfirm = false,
  errorNex = false
) {
  return new Promise((resolve, reject) => {
    let param = templateUtil.compileData(menuParameter.param, data)
    if (!param || !param.url) {
      const msg = 'menuParameter 参数，不合法： param.url 必填'
      console.error(msg)
      vue.$Message.error(msg)
      return
    }
    // 动态参数
    var requestParam = templateUtil.compileData(menuParameter.requestParam, data)

    // 支持请求类的处理方法获取高级查询条件参数, methodName使用 getExportOfCondition
    var methodName = param.methodName || ''
    if (methodName) {
      var getExportOfConditionFN = vue[methodName]
      if (vue.parentVue && vue.parentVue[methodName]) {
        getExportOfConditionFN = vue.parentVue[methodName]
      }
      if (typeof getExportOfConditionFN === 'function') {
        var sourceData = getExportOfConditionFN()
        var postParam = sourceData ? sourceData.parameters : {}
        if (vue.parentVue && vue.parentVue.selectionIds && vue.parentVue.selectionIds.length > 0) {
          postParam.ids = vue.parentVue.selectionIds
        } else if (postParam.hasOwnProperty('ids')) {
          delete postParam.ids
        }
        requestParam.parameters = Object.assign(postParam, requestParam.parameters)
      }
    }
    let ifForm = param.submit === undefined ? form : param.submit
    let temParams = ifForm ? Object.assign({}, data.data) : requestParam
    let specialTemParam = null //用于特殊业务传递参数，不影响formData
    if (ifForm) {
      if (param.optional == 'NO_OPTION') {
        // 货位 待处理-来自采购验收单 采购入库单
        // 循环赋值
        if (param.shoppingData) specialTemParam = objectUtil.clone(temParams.formData) //待处理-来自采购验收单
        Object.keys(requestParam.margeFormData).forEach((elem) => {
          if (specialTemParam)
            objectUtil.setValueByPath(specialTemParam, elem, requestParam.margeFormData[elem])
          else objectUtil.setValueByPath(temParams, elem, requestParam.margeFormData[elem])
        })
      } else if (param.submitDialogCode) {
        // 需求7420：在提交之前需要加入原因填写，而该原因字段不能放在optional中而是赋值给放在外面的相应字段中
        temParams[param.submitDialogCode] = requestParam[param.submitDialogCode]
      } else temParams.optional = requestParam
    }
    if (!param.method) param.method = method
    if (param.method && param.method === 'get') {
      if (specialTemParam) specialTemParam = { params: specialTemParam }
      else temParams = { params: temParams }
    }
    // 异步任务立即执行按钮，在执行动作，静态属性配置，nowExecute：true，表示这个按钮，页面进入就要执行
    const isNowExecute = param.nowExecute
    menuUtils.special
      .ifConfirm(vue, param, defaultIfConfirm)
      .then((isRight) => {
        if (isRight === 'RIGHT') {
          if (specialTemParam) specialTemParam.param = { rightClick: true }
          else temParams.param = { rightClick: true } // 弹窗确认点击右边的按钮 给一个标记
        }
        vue.$Loading.start()
        vue.$set(
          menuParameter._oldParameter ? menuParameter._oldParameter : menuParameter,
          'loading',
          true
        )
        if (!document.leadLoad) {
          document.leadLoad = vue.$pgMessage.leadLoading({
            loadingText: '请求中...',
            terminationText: '请求成功',
            isBody: false,
          })
        }
        vue.$axios[param.method](param.url, specialTemParam || temParams)
          .then((res) => {
            vue.$Loading.finish()
            if (!(isNowExecute && res.data.progressTask)) {
              menuParameter._oldParameter
                ? (menuParameter._oldParameter.loading = false)
                : (menuParameter.loading = false)
              if (document.leadLoad) {
                document.leadLoad.cancel()
                delete document.leadLoad
              }
            }
            if (res.data.code != 200) {
              if (res.data.code === 400) {
                //强制提交
                if (errorCallback) errorCallback(res)
                menuUtils.special
                  .forceSubmit(vue, menuParameter, data, res, ifForm, callback, errorCallback)
                  .then((res) => {
                    resolve(res)
                  })
                  .catch((res) => {
                    reject(res)
                  })
              } else {
                if (!errorNex && !param.errorNex) {
                  param.showToast
                    ? vue.$Message.error(res.data.errors)
                    : vue.$cfn.ajax1.isOK(res, vue)
                  reject(res)
                } else {
                  vue.$pgMessage.confirm({
                    title: param.title || '提示',
                    content: param.content || res.data.msg,
                    sureBtnText: param.sureBtnText || '确定',
                    showCancelBtn: false,
                    onOk: () => {
                      vue.$nextTick(() => {
                        resolve(res)
                      })
                    },
                    cancel: () => {
                      reject(res)
                    },
                  })
                }
              }
              return
            }

            if (res.data.progressTask) {
              //异步任务
              menuUtils.special.progressTask(vue, res.data.progressTask, param).then((data) => {
                if (document.leadLoad) {
                  document.leadLoad.cancel()
                  delete document.leadLoad
                }
                menuParameter._oldParameter
                  ? (menuParameter._oldParameter.loading = false)
                  : (menuParameter.loading = false)
                let response = param.isProgressTaskRes ? data : res
                if (response.data.code === 400) {
                  //强制提交
                  if (errorCallback) errorCallback(response, param.updateData)
                  menuUtils.special
                    .forceSubmit(
                      vue,
                      menuParameter,
                      data,
                      response,
                      ifForm,
                      callback,
                      errorCallback
                    )
                    .then((res) => {
                      if (param.afterMethod) {
                        const that = vue.parentVue ?? vue
                        that[param.afterMethod]?.()
                      }
                      resolve(res)
                    })
                    .catch((res) => {
                      reject(res, param.updateData)
                    })
                } else {
                  if (param.afterMethod) {
                    const that = vue.parentVue ?? vue
                    that[param.afterMethod]?.()
                  }
                  resolve(response)
                }
              })
            } else {
              //成功后的提示类型
              if (document.leadLoad) {
                document.leadLoad.cancel()
                delete document.leadLoad
              }
              menuUtils.special.tipFn(vue, res.data, param, data)
              if (param.afterMethod) {
                const that = vue.parentVue ?? vue
                that[param.afterMethod]?.()
              }
              // #36815
              if (param.afterTopMindReload) {
                menuUtils.typeMethod.updateTopMindReload(vue, menuParameter, { response: res })
              }
              resolve(res)
            }
          })
          .catch((res) => {
            if (document.leadLoad) {
              document.leadLoad.cancel()
              delete document.leadLoad
            }
            vue.$Loading.error()
            menuParameter._oldParameter
              ? (menuParameter._oldParameter.loading = false)
              : (menuParameter.loading = false)
            vue.$cfn.ajax1.catch1(res, vue)
          })
      })
      .catch(() => {
        if (document.leadLoad) {
          document.leadLoad.cancel()
          delete document.leadLoad
        }
        console.info('menuUtils.special.ifConfirm 点击取消按钮')
        reject(null)
      })
  })
}
/**

 @param vue
 @param menuParameter 菜单定义
 @param data  业务数据对象
 @param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"router",
    "icon":"edit",
    "name":"编辑",
    "param":{
        "path":"this.routerEdit",
        "name":"this.routerEdit"
    },
    "requestParam":{"id":"{{data.id}}","userId":{{user.id}}}

}
*/
menuUtils.typeMethod.router = function (vue, menuParameter, compileVariableData) {
  return new Promise((resolve) => {
    // 静态参数也支持，模板编译，应用场景： 请求路径是动态生成的。
    var param = templateUtil.compileData(menuParameter.param, compileVariableData)
    param.query = templateUtil.compileData(menuParameter.requestParam, compileVariableData)
    if (param.ifSystem && param.query.itemData) {
      routerSystem(
        vue,
        vue.$store.state.user.currentToken.id,
        vue.GLOBAL.domain,
        param.query.itemData,
        param.processKey
      )
    } else {
      if (!param.path && !param.name) {
        console.error('menuParameter 参数，不合法： !param.path && !param.name==true')
        alert('menuParameter 参数，不合法： !param.path && !param.name==true')
        return
      }
      vue.$router.push(param)
    }

    resolve(null)
  })
}

/**
根据code跳转页面
 @param vue
 @param menuParameter 菜单定义
 @param data  业务数据对象
 @param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"router",
    "icon":"edit",
    "name":"编辑",
    "param":{
        "path":"this.routerEdit",
        "name":"this.routerEdit",
        "url":"~static/mock/orderTypeRouter.json"
    },
    "requestParam":{"id":"{{data.id}}","userId":{{user.id}}}

}
*/
menuUtils.typeMethod.orderRouter = function (vue, menuParameter, data) {
  return new Promise((resolve) => {
    var param = Object.assign(
      {
        url: '~static/mock/orderTypeRouter.json',
      },
      menuParameter.param
    )
    param.query = templateUtil.compileData(menuParameter.requestParam, data)
    if (!param.query || !param.query.codeKey) {
      console.error('menuParameter 参数，不合法： !param.query || !param.query.codeKey')
      return
    }
    cacheRequest
      .getCatchData('get', param.url, {}, vue, 86400000)
      .then((res) => {
        if (!vue.$cfn.ajax1.isOK(res, vue)) return
        let codeObj = res.data.data
        for (let item in codeObj) {
          if (item == param.query.codeKey) {
            // lqn 20190918 2281 跳转详情时添加
            if (codeObj[item].routeFunction && vue.$customGoRouter) {
              if (codeObj[item].type) {
                vue.$customGoRouter[codeObj[item].routeFunction](
                  param.query,
                  vue,
                  codeObj[item].type
                )
              } else {
                vue.$customGoRouter[codeObj[item].routeFunction](param.query, vue)
              }
            } else {
              param.name = codeObj[item].name
              delete param.query.codeKey
              delete param.url
              param.query = Object.assign(codeObj[item].param, param.query)
              vue.$router.push(param)
              resolve(null)
            }
            break
          }
        }
      })
      .catch((res) => {
        // 设计器阶段，导致接口调用不通过情况，不弹出错误信息。
        console.error('menuUtils.typeMethod.orderRouter:', res)
        // this.$cfn.ajax1.catch1(res, this);
      })
  })
}

/**
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"confirm",
    "icon":"trash-b",
    "name":"删除",
    "param":{
        "title":"删除",
        "content":"<p>确定要删除</p>",
        "method":"post",
        "url":"rest/main/system/system/remove",
        "queryParam":{"id":"{{id}}"}
    }
*/
menuUtils.typeMethod.confirm = function (vue, menuParameter, data, callback, errorCallback) {
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    false,
    true
  )
}

/**

submit :提交请求
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"submit",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/remove",
        "queryParam":{"id":"{{id}}"}
    }
*/

menuUtils.typeMethod.submit = function (vue, menuParameter, data, callback, errorCallback) {
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    false,
    true
  )
}

/**

requerst :无弹窗提交请求
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"requerst",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/remove",
        "queryParam":{"id":"{{id}}"}
    }
*/

menuUtils.typeMethod.requerst = function (vue, menuParameter, data, callback, errorCallback) {
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    false,
    false
  )
}
/**

requerstConfirm :可打断后续动作弹窗请求(post)
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"requerstConfirm",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/remove",
        "queryParam":{"id":"{{id}}"}
    }
*/

menuUtils.typeMethod.requerstConfirm = function (
  vue,
  menuParameter,
  data,
  callback,
  errorCallback
) {
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    false,
    false,
    true
  )
}

/**
 *  submitFormDataBefore 提交form表单前置钩子
 *
 *  @param vue
 *  @param menuParameter
 *  @param data
 */

menuUtils.typeMethod.handleSubmitFormDataBefore = function (
  vue,
  menuParameter,
  data,
  callback,
  errorCallback
) {
  // 传入callback, 成功后调用submitFormData
  if (
    menuParameter.requestParam.handleSubmitFormDataBefore &&
    vue[menuParameter.requestParam.handleSubmitFormDataBefore]
  ) {
    return new Promise((resolve, reject) => {
      vue[menuParameter.requestParam.handleSubmitFormDataBefore](data).then((res) => {
        menuUtils.typeMethod
          .submitFormData(vue, menuParameter, res, callback, errorCallback)
          .then((res) => {
            resolve(res)
          })
          .catch((res) => {
            reject(res)
          })
      })
    })
  } else {
    return menuUtils.typeMethod.submitFormData(vue, menuParameter, data, callback, errorCallback)
  }
}

/**
submitFormData :提交from表单，做校验
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"submitFormData",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/save"
    }
*/

menuUtils.typeMethod.submitFormData = function (vue, menuParameter, data, callback, errorCallback) {
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    true,
    true,
    false
  )
}

/**

saveFormData :保存from表单，做校验
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"saveFormData",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/save"
    }
*/
menuUtils.typeMethod.saveFormData = function (vue, menuParameter, data, callback, errorCallback) {
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    true,
    false,
    false
  )
}

/**

wholeFormData :提交from表单，不做校验（弹窗确认）
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"submitFormData",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/save"
    }
*/

menuUtils.typeMethod.wholeFormData = function (vue, menuParameter, data, callback, errorCallback) {
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    true,
    true,
    false
  )
}

/**

deleteSubmit :删除提交。
提示语由前端控制，不用配置。
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"submit",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/remove",
        "queryParam":{"id":"{{id}}"}
    }
*/
menuUtils.typeMethod.deleteSubmit = function (
  vue,
  menuParameter,
  data,
  callback,
  errorCallback,
  componentName
) {
  if (!menuParameter.param.title) {
    menuParameter.param.title = '删除'
  }
  if (!menuParameter.param.content) {
    menuParameter.param.content = '<p>确认删除？</p>'
  }
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    false,
    true,
    false,
    componentName
  )
}

/**
unApproveSubmit :弃审提交。
提示语由前端控制，不用配置。
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"submit",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/remove",
        "queryParam":{"id":"{{id}}"}
    }
*/
menuUtils.typeMethod.unApproveSubmit = function (
  vue,
  menuParameter,
  data,
  callback,
  errorCallback
) {
  if (!menuParameter.param) menuParameter.param = {}
  if (!menuParameter.param.content) {
    menuParameter.param.content = '<p>确认弃审？</p>'
  }
  menuParameter.param.title = '确认提示'
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    false,
    true,
    false
  )
}
/**

cancelSubmit :撤销提交。
提示语由前端控制，不用配置。
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"submit",
    "icon":"trash-b",
    "name":"提交",
    "param":{
        "method":"post",
        "url":"rest/main/system/system/remove",
        "queryParam":{"id":"{{id}}"}
    }
*/
menuUtils.typeMethod.cancelSubmit = function (vue, menuParameter, data, callback, errorCallback) {
  if (!menuParameter.param) menuParameter.param = {}
  menuParameter.param.title = menuParameter.param.title || '撤销'
  menuParameter.param.content = menuParameter.param.content || '<p>确认撤销？</p>'
  return menuUtils.typeMethod.requerstData(
    vue,
    menuParameter,
    data,
    callback,
    errorCallback,
    'post',
    false,
    true,
    false
  )
}

/**
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"closeCurrentTabAndRouter",
    "icon":"trash-b",
    "name":"关闭并跳转",
    "param":{

    }
*/
menuUtils.typeMethod.closeCurrentTabAndRouter = function (vue, menuParameter, data) {
  var item = vue.$store.state.menuStore.currentRouter
  var closename = item.id
  // 静态参数也支持，模板编译，应用场景： 请求路径是动态生成的。
  var param = templateUtil.compileData(menuParameter.param, data)
  param.query = templateUtil.compileData(menuParameter.requestParam, data)
  if (!param.path && !param.name) {
    console.error('menuParameter 参数，不合法： !param.path && !param.name==true')
    alert('menuParameter 参数，不合法： !param.path && !param.name==true')
    return
  }
  // 合并业务。
  vue.$store.commit('closeTabByname', {
    id: closename,
    vm: vue,
  })
  vue.$router.push(param)
}

/**
@description #6643, 页面跳转优化
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"closeCurrentTabAndRouter",
    "icon":"trash-b",
    "name":"关闭并跳转",
    "param":{

    }
*/
menuUtils.typeMethod.closeCurrentTabAndRouterBizCode = function (vue, menuParameter, data) {
  var item = vue.$store.state.menuStore.currentRouter
  var closename = item.id
  // 静态参数也支持，模板编译，应用场景： 请求路径是动态生成的。
  var param = templateUtil.compileData(menuParameter.param, data)
  param.query = templateUtil.compileData(menuParameter.requestParam, data)

  const routerDataObj = {
    url: '~static/mock/orderTypeRouter.json',
    method: 'get',
    params: null,
  }
  let params = Object.assign({}, routerDataObj.params)
  params = {
    params,
  }

  vue.$axios
    .get(routerDataObj.url, params)
    .then((res) => {
      if (!vue.$cfn.ajax1.isOK(res, this)) return
      const routerData = res.data.data
      console.log(routerData[param.query.bizCode], routerData)
      param.name = routerData[param.query.bizCode].name

      if (!param.name) {
        console.error('menuParameter 参数，不合法： !param.name==true')
        // alert('menuParameter 参数，不合法： !param.path && !param.name==true')
        return
      }
      // 合并业务。
      vue.$store.commit('closeTabByname', {
        id: closename,
        vm: vue,
      })

      const router = vue.$router || window.$vueApp.$router
      router.push(param)
    })
    .catch((res) => {
      vue.$cfn.ajax1.catch1(res, vue)
    })
}

/**
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作
menuParameter={
    "type":"confirmAndRouter",
    "icon":"trash-b",
    "name":"根据弹框选择，跳转对应页面",
    "param":{
        title:弹框标题,
        content：弹框内容,
        sureBtnText：确认按钮名称,
        showCancelBtn：是否展示取消按钮,
        cancelBtnText：取消按钮名称,
        name：确认按钮跳转的路由,
        namecancel：取消按钮跳转的路由
    },
    "requestParam":{
        queryOk:{ //确认按钮跳转所需参数
            function:901010,
            id
        },
        queryCancel:{ //取消按钮跳转所需参数
            function:901010,
            id
        }
    }
*/
menuUtils.typeMethod.confirmAndRouter = function (vue, menuParameter, data) {
  var item = vue.$store.state.menuStore.currentRouter
  var closename = item.id
  // 静态参数也支持，模板编译，应用场景： 请求路径是动态生成的。
  var param = templateUtil.compileData(menuParameter.param, data)
  if (!param.path && !param.name) {
    alert('menuParameter 参数，不合法： !param.path && !param.name==true')
    return
  }
  // 信息确认框
  vue.$pgMessage.confirm({
    title: param.title || '确认',
    content: param.content || '确定继续',
    sureBtnText: param.sureBtnText || '是',
    showCancelBtn: param.showCancelBtn ?? true,
    cancelBtnText: param.cancelBtnText || '否',
    onOk: () => {
      param.query = templateUtil.compileData(menuParameter.requestParam.queryOk, data)
      if (param.name !== vue.$route.name || vue.$route.query?.id) {
        // 关闭之前的页面
        vue.$store.commit('closeTabByname', {
          id: closename,
          vm: vue,
        })
        vue.$router.push(param)
      } else {
        const refresh = vue.parentVue?.refresh ?? vue.refresh
        refresh()
      }
    },
    cancel: () => {
      if (!param.namecancel) {
        alert('menuParameter 参数，不合法： param.namecancel为必填')
        return
      }
      vue.$store.commit('closeTabByname', {
        id: closename,
        vm: vue,
      })
      param.name = param?.namecancel
      param.query = templateUtil.compileData(menuParameter.requestParam.queryCancel, data)
      vue.$router.push(param)
    },
  })
}

/**
@param vue
@param menuParameter 菜单定义
@param data  业务数据对象
@param user  当前用户，用于过来权限等操作

menuParameter={
    "type":"icon",
    "icon":"trash-b",
    "name":"延迟关闭并跳转",
    "param":{

    }
*/
menuUtils.typeMethod.closeCurrentTabAndRouterDefer = function (vue, menuParameter, data) {
  var item = vue.$store.state.menuStore.currentRouter
  var closename = item.id
  // 静态参数也支持，模板编译，应用场景： 请求路径是动态生成的。
  var param = templateUtil.compileData(menuParameter.param, data)
  param.query = templateUtil.compileData(menuParameter.requestParam, data)
  if (!param.path && !param.name) {
    console.error('menuParameter 参数，不合法： !param.path && !param.name==true')
    alert('menuParameter 参数，不合法： !param.path && !param.name==true')
    return
  }
  setTimeout(() => {
    vue.$router.push(param)
    vue.$store.commit('closeTabByname', {
      id: closename,
      vm: vue,
    })
  }, 1000)
}

/**
 * @name: 自定义组件
 * @test: test font
 * @msg:
 * @param {type}
 * @return:
 */
menuUtils.typeMethod.component = function (vue, menuParameter, data, callback) {
  return new Promise(async (resolve, reject) => {
    var param = templateUtil.compileData(menuParameter.param, data)
    if (param.isValidate) {
      const validateFn = vue.validate ?? vue.parentVue.validate
      if (validateFn) {
        const validateErrot = await new Promise((resolveValidate) => {
          validateFn(
            () => resolveValidate(false),
            () => resolveValidate(true)
          )
        })
        if (validateErrot) {
          vue.$Message.error('请完善必填信息!')
          reject()
          return
        }
      }
    }
    if (!param.isRender) {
      param.query = templateUtil.compileData(menuParameter.requestParam, data)
      // 将store向下传递
      if (vue.store) {
        param.query.store = vue.store
      }
      //将自定义的store向下传递
      if (vue.specialState) {
        param.query.specialState = vue.specialState
      }
      if (vue.specialMutations) {
        param.query.specialMutations = vue.specialMutations
      }
      if (vue.specialActions) {
        param.query.specialActions = vue.specialActions
      }
    }

    if (!param.component) {
      let msg = 'menuParameter 参数，不合法： param.components 必填'
      console.error(msg)
      alert(msg)
      return
    }
    var componentClassName = param.component
    if (!vue.$allComponents) {
      vue.$allComponents = {}
    }

    var componentClass = vue.$allComponents[componentClassName]
    if (!componentClass) {
      var tempcomponentClassName = componentClassName.replace(/([A-Z])/g, '-$1').toLowerCase()
      componentClass = vue.$allComponents[tempcomponentClassName]
    }
    // 支持直接使用名字创建
    if (!componentClass) {
      componentClass = componentClassName
    }
    if (!componentClass) {
      let msg = '组件不存在：' + param.component
      console.error(msg)
      alert(msg)
    }

    if (vue.$el.querySelector('#' + componentClassName)) {
      return
    }

    let Instance = new Vue({
      render(h) {
        if (param.isRender) {
          param.query = templateUtil.compileData(menuParameter.requestParam, data)

          // 将store向下传递
          if (vue.store) {
            param.query.store = vue.store
          }
        }
        const cVnode = h(componentClass, {
          on: {
            'on-ok-and-continue': (fromData) => {
              // 调用后置方法不销毁组件,满足侧滑添加后不销毁实例继续操作，示例，iscc价格变更-编辑
              // InstanceDaed(Instance)
              if (callback) callback(fromData)
            },
            'on-ok': async (fromData) => {
              let flage = false
              //支持组件不销毁前执行一个动作
              if (param.actions) {
                const actionsParam =
                  templateUtil.compileData(menuParameter.requestParam?.actionsParam, data) ?? {}
                flage = await vue.store.dispatch(param.actions, data, vue, {
                  ...actionsParam,
                  data: fromData,
                })
              }
              if (!param.actions || flage) {
                resolve(fromData)
                InstanceDaed(Instance)
              }
            },
            'on-cancel': () => {
              InstanceDaed(Instance)
            },
            cancel: () => {
              InstanceDaed(Instance)
            },
            'on-error': (res) => {
              reject(res)
              InstanceDaed(Instance) //这里将实例销毁后点击继续审核会无法执行后置动作
            },
          },
          props: param.query,
        })
        const transparentMask = h(
          'div',
          {
            style: {
              position: 'fixed',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              zIndex: 30,
            },
            on: {
              click: (e) => e.stopPropagation(),
            },
          },
          [cVnode]
        )
        return document.querySelector('#section-mask') ||
          componentClassName === 'auditComent' ||
          param.noMask
          ? cVnode
          : h(
              'section',
              {
                attrs: { id: 'section-mask' },
                style: {
                  position: 'fixed',
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0,0,0,.3)',
                  top: 0,
                  left: 0,
                  zIndex: 41,
                },
                on: {
                  click: () => {
                    InstanceDaed(Instance)
                  },
                },
              },
              [transparentMask]
            )
      },
    })
    Instance.$parent = vue
    // #7897 指定的组件，将 vue 传给侧滑
    const comps = ['scanStandardPlus']
    if (comps.includes(componentClassName)) {
      Instance.$vue = vue
    }
    //将策略等辅助信息也给到侧滑
    Instance.$store = vue.$store
    let dyncComponent = Instance.$mount().$el
    if (param.transfer) {
      // 是否放入 domTransfer or body
      const domTransfer = document.querySelector('#routerView') || document.body
      domTransfer.appendChild(dyncComponent)
    } else {
      vue.$el.appendChild(dyncComponent)
    }
  })
}

/**
menuParameter={
"type": "method",
"name": "高级查询",
"param": {"methodName":"menuClickOfAdvancedQuery"},
"requestParam": {}
}
推荐命名规则：
//动态菜单，点击方法-高级查询
methodName=menuClickOf  (前缀开头)
menuClickOfAdvancedQuery(menuParameter,data,callback)
*/
menuUtils.typeMethod.method = function (vue, menuParameter, data) {
  return new Promise((resolve) => {
    var param = templateUtil.compileData(menuParameter.param, data)
    if (!param || !param.methodName) {
      vue.$Message.error('按钮参数错误，type=method，参数methodName不能为空')
      return
    }

    var fn = vue[param.methodName]
    // 优先级1，在菜单父类方法获取
    if (vue.parentVue) {
      let fn = vue.parentVue[param.methodName]
      if (typeof fn == 'function') {
        fn.call(vue, menuParameter, data, (res) => {
          resolve(res)
        })
        return
      }
    }
    // 优先级2，在菜单内部方法获取
    if (typeof fn == 'function') {
      fn.call(vue, menuParameter, data, (res) => {
        resolve(res)
      })
      return
    }
    vue.$Message.error('按钮参数错误，type=method，参数methodName没有可以调用的方法')
  })
}

/**
exportOfCondition:基于高级查询结构导出
    {
          "type":"exportOfCondition",
            "cssType":"warning",
          "icon":"trash-b",
          "name":"导出",
          "param":{
              "criteriaCode":""ISCC_ORDER_TEMPLATE_ALLOCATION_QUERY"",
              "tableCode":""

          },
        "requestParam":{
          "method":"post",
          "url":"rest/main/system/system/exportOfCondition"
        }
}，
*/

menuUtils.typeMethod.printing = function (vue, menuParameter, data) {
  // var param = menuParameter.param;
  // 静态参数也支持，模板编译，应用场景： 请求路径是动态生成的。
  var param = templateUtil.compileData(menuParameter.param, data)
  if (!param || !param.url) {
    var msg = 'menuParameter参数，不合法： param.url 必填'
    console.error(msg)
    alert(msg)
    return
  }
  // 解析动态参数
  var requestParam = templateUtil.compileData(menuParameter.requestParam, data)
  var postParam = {}
  // 获取高级查询参数
  if (!param.isDetail) {
    var methodName = 'getExportOfCondition' || param.methodName
    var getExportOfConditionFN = vue[methodName]
    // 优先级1，在菜单父类方法获取
    if (vue.parentVue) {
      // 盘点单库存编辑-导出 vue.parentVue[getExportOfConditionFN] 不存在
      if (vue.parentVue[methodName]) {
        getExportOfConditionFN = vue.parentVue[methodName]
      }
    }
    if (typeof getExportOfConditionFN != 'function') {
      alert('当前组件，未实现方法:getExportOfCondition')
      console.error('当前组件，未实现方法:getExportOfCondition')
      return
    }
    var sourceData = getExportOfConditionFN()
    postParam = sourceData ? sourceData.parameters : {}
    if (vue.parentVue && vue.parentVue.selectionIds && vue.parentVue.selectionIds.length > 0) {
      postParam.ids = vue.parentVue.selectionIds
    } else if (postParam.hasOwnProperty('ids')) {
      delete postParam.ids
    }
  }
  if (requestParam) {
    postParam = Object.assign(postParam, requestParam)
  }
  let temUrl = param.url
  if (
    temUrl.indexOf('http://') == -1 &&
    temUrl.indexOf('https://') == -1 &&
    data.GLOBAL.findBiUrl
  ) {
    temUrl = data.GLOBAL.findBiUrl + temUrl
  }
  temUrl = urlUitls.setRequestParamter(temUrl, postParam)
  var win1 = window.open(temUrl)
  if (!win1 || !win1.location) {
    vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
  }
}

menuUtils.typeMethod.exportOfCondition = function (vue, menuParameter, data, callback) {
  return new Promise((resolve, reject) => {
    // 静态参数也支持，模板编译，应用场景： 请求路径是动态生成的。
    var param = templateUtil.compileData(menuParameter.param, data)
    if (!param || !param.url) {
      var msg = 'menuParameter 参数，不合法： param.url 导出必填'
      console.error(msg)
      alert(msg)
      return
    }
    var requestParam = templateUtil.compileData(menuParameter.requestParam, data)
    var methodName = param.methodName ?? 'getExportOfCondition'
    var getExportOfConditionFN = vue[methodName]

    // 优先级1，在菜单父类方法获取
    if (vue.parentVue) {
      // 盘点单库存编辑-导出 vue.parentVue[getExportOfConditionFN] 不存在
      if (vue.parentVue[methodName]) {
        getExportOfConditionFN = vue.parentVue[methodName]
      }
    }

    if (typeof getExportOfConditionFN != 'function') {
      alert('当前组件，未实现方法:getExportOfCondition')
      console.error('当前组件，未实现方法:getExportOfCondition')
      return
    }

    var sourceData = getExportOfConditionFN()
    var postParam = sourceData
    if (requestParam) {
      let parameters = {}
      if (requestParam.parameters) {
        parameters = Object.assign({}, requestParam.parameters, sourceData['parameters'])
        postParam = Object.assign({}, sourceData, requestParam)
        postParam['parameters'] = parameters
      } else {
        postParam = Object.assign({}, sourceData, requestParam)
      }
    }
    console.info('requestParam:param, sourceData', param, sourceData)
    let confirm = function () {
      vue.$pgMessage.confirm({
        title: param.title || '导出',
        content: param.content || '确认导出？',
        onOk: (dead) => {
          if (dead) dead()
          vue.$Loading.start()
          vue.$set(menuParameter, 'loading', true)
          vue.$axios
            .post(param.url, postParam)
            .then((res) => {
              vue.$Loading.finish()
              menuParameter.loading = false
              if (!vue.$cfn.ajax1.isOK(res, vue)) return
              if (res.data.progressTask) {
                menuUtils.special.progressTask(vue, res.data.progressTask, param).then((data) => {
                  // 支持在progressTask 中下载，该处做兼容性处理。
                  if (!res.data.data || res.data.data.url) return
                  var win1 = window.open(res.data.data.url)
                  if (!win1 || !win1.location) {
                    vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
                    return
                  }
                  resolve(data)
                })
              } else {
                vue.$Message.success(res.data.msg)
                var win1 = window.open(res.data.data.url)
                if (!win1 || !win1.location) {
                  vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
                  return
                }
                resolve(res)
              }
              if (Instance) {
                InstanceDaed(Instance)
              }
            })
            .catch((res) => {
              vue.$Loading.error()
              menuParameter.loading = false
              vue.$cfn.ajax1.catch1(res, vue)
              if (Instance) {
                InstanceDaed(Instance)
              }
            })
        },
      })
    }
    if (param.useSide) {
      let componentClass = 'sideExport'
      let comProps = { value: postParam }
      if (param.tableUrl) comProps.getDataUrl = param.tableUrl

      //需求6010 导出接口参数修改 - param.exportParamsValue 取值： id -> code
      if (param.exportParamsValue) comProps.exportParamsValue = param.exportParamsValue
      var Instance = new Vue({
        render(h) {
          const cVnode = h(componentClass, {
            on: {
              'on-ok-and-continue': (fromData) => {
                // 调用后置方法不销毁组件,满足侧滑添加后不销毁实例继续操作，示例，iscc价格变更-编辑
                // InstanceDaed(Instance)
                if (callback) callback(fromData)
              },
              'on-ok': (fromData) => {
                let postParams = JSON.parse(JSON.stringify(postParam))
                //需求6010 导出接口参数修改- param.exportParamsKey取值： columnIds -> columnCodes
                postParams.parameters[param.exportParamsKey ?? 'columnIds'] = fromData.checkAllGroup
                postParams.parameters.exportExcelTitle = fromData.exportExcelTitle
                vue.$Loading.start()
                cVnode.child.loading = true
                vue.$set(menuParameter, 'loading', true)
                vue.$axios
                  .post(param.url, postParams)
                  .then((res) => {
                    vue.$Loading.finish()
                    menuParameter.loading = false
                    cVnode.child.loading = false
                    if (!vue.$cfn.ajax1.isOK(res, vue)) return
                    if (res.data.progressTask) {
                      menuUtils.special
                        .progressTask(vue, res.data.progressTask, param)
                        .then((data) => {
                          // 支持在progressTask 中下载，该处做兼容性处理。
                          if (!res.data.data || res.data.data.url) return
                          var win1 = window.open(res.data.data.url)
                          if (!win1 || !win1.location) {
                            vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
                            return
                          }
                          resolve(data)
                        })
                    } else {
                      vue.$Message.success(res.data.msg)
                      var win1 = window.open(res.data.data.url)
                      if (!win1 || !win1.location) {
                        vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
                        return
                      }
                      resolve(res)
                    }
                    if (Instance) {
                      InstanceDaed(Instance)
                    }
                  })
                  .catch((res) => {
                    vue.$Loading.error()
                    menuParameter.loading = false
                    cVnode.child.loading = false
                    vue.$cfn.ajax1.catch1(res, vue)
                    if (Instance) {
                      InstanceDaed(Instance)
                    }
                  })
              },
              'on-cancel': () => {
                InstanceDaed(Instance)
              },
              cancel: () => {
                InstanceDaed(Instance)
              },
              'on-error': (res) => {
                reject(res)
                InstanceDaed(Instance) //这里将实例销毁后点击继续审核会无法执行后置动作
              },
            },
            props: comProps,
          })
          const transparentMask = h(
            'div',
            {
              style: {
                position: 'fixed',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                zIndex: 30,
              },
              on: {
                click: (e) => e.stopPropagation(),
              },
            },
            [cVnode]
          )
          return document.querySelector('#section-mask')
            ? cVnode
            : h(
                'section',
                {
                  attrs: { id: 'section-mask' },
                  style: {
                    position: 'fixed',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,.3)',
                    top: 0,
                    left: 0,
                    zIndex: 29,
                  },
                  on: {
                    click: () => {
                      InstanceDaed(Instance)
                    },
                  },
                },
                [transparentMask]
              )
        },
      })
      Instance.$parent = vue
      let dyncComponent = Instance.$mount().$el
      const domTransfer = document.body
      domTransfer.appendChild(dyncComponent)
    } else {
      confirm()
    }
  })
}

/**
  openWindow :新开窗口
*/
menuUtils.typeMethod.openWindow = function (vue, menuParameter, data) {
  return new Promise((resolve) => {
    // 合并菜单按钮参数，到动态表单一起提交。
    var param = templateUtil.compileData(menuParameter.param, data)
    if (param) {
      if (param.showAlert) {
        vue.$pgMessage.confirm({
          title: param.title || '确认',
          content: param.content || '确认提交？',
          sureBtnText: param.sureBtnText,
          showCancelBtn: param.cancelBtnText ?? true,
          cancelBtnText: param.cancelBtnText || '取消',
          onOk: () => {
            resolve(null)
          },
          cancel: () => {
            resolve(null)
          },
        })
      }
    }
    var requestParam = templateUtil.compileData(menuParameter.requestParam, data)
    if (!requestParam.path) {
      console.error('menuParameter 参数，不合法：requestParam.path 必填是url格式')
      alert('menuParameter 参数，不合法：requestParam.path 必填是url格式')
      return
    }
    //当使用接口返回的url需要编译时
    if (param.againCompile) {
      requestParam.path = templateUtil.compileData(requestParam.path, data)
    }
    // eslint-disable-next-line no-global-assign
    if (requestParam.name) name = requestParam.name
    // 付款管理-在线支付单-支付操作 需求2986
    if (param.applyPay) {
      let Instance = new Vue({
        render(h) {
          return h('div', {
            attrs: { id: 'applyPay' },
            domProps: {
              innerHTML: requestParam.path,
            },
            ref: 'applyPay',
            show: false,
          })
        },
      })
      Instance.$parent = vue
      let dyncComponent = Instance.$mount().$el
      vue.$el.appendChild(dyncComponent)
      vue.$nextTick(() => {
        Instance.$refs.applyPay.querySelector('form').setAttribute('target', '_blank')
        Instance.$refs.applyPay.querySelector('form').submit()
        InstanceDaed(Instance)
      })
    } else {
      //如果是get 拼接path
      if (requestParam?.method == 'get') {
        requestParam.path = urlUitls.setRequestParamter(requestParam.path, requestParam.parameters)
      }
      var win1 = window.open(requestParam.path, name)
      if (!win1 || !win1.location) {
        vue.$Message.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
      }
    }
    if (param) {
      if (!param.showAlert) {
        resolve(null)
      }
    }
  })
}

/**
 * refreshData ：刷新页面
 */
menuUtils.typeMethod.refreshData = function (vue) {
  return new Promise((resolve) => {
    if (vue.parentVue) {
      vue.parentVue.reload()
      resolve(null)
    } else if (vue.reload) {
      vue.reload()
      resolve(null)
    } else {
      vue.$Message.info('此页面不可以刷新...')
    }
  })
}

/**
 * updateFormData : 返回数据更新到表单
 */
menuUtils.typeMethod.updateFormData = function (vue, menuParameter, data) {
  const getTargetComponent = (target) => {
    let aimComponent = target
    while (aimComponent && aimComponent.$options.name !== 'crudEdit') {
      aimComponent = aimComponent.$parent
    }
    return aimComponent
  }
  var that = getTargetComponent(vue) // vue.parentVue ? vue.parentVue : vue;
  if (!that) {
    console.error('updateFormData--->vue不存在')
    return false
  }
  // 当传入的response不满足结构时需要进行转换
  let resObj = data.response ? data.response : JSON.parse(JSON.stringify(data)),
    temp = {}
  if (!resObj.data) {
    temp = {
      data: {
        code: 200,
        errors: null,
        msg: '成功',
        progressTask: null,
        success: true,
        data: resObj,
      },
    }
  } else if (data.response) {
    temp = data.response
  }
  if (that.getOfEditSuccess) {
    that.getOfEditSuccess(temp)
  } else {
    that.formData = temp.data.data
    that.responseData = temp.data
    that.broadcast('panguTable', 'on-table-change')
  }

  if (that.updateTable && typeof that.updateTable == 'function') {
    that.updateTable()
  }
}

/**
 * updateTopMindReload : 返回数据更新到顶部提示信息（寄售还回单、跟台登记使用）表单。
 */
menuUtils.typeMethod.updateTopMindReload = function (vue, menuParameter, data) {
  var that = vue.parentVue ? vue.parentVue : vue
  let updateErrors = function () {
    that.onTableButtonErrors(data.response.data, menuParameter.param)
  }
  if (vue.parentVue && typeof vue.parentVue.reload == 'function') {
    vue.parentVue.reload(updateErrors)
  } else {
    vue.reload(updateErrors)
  }
  that.topMindSpecial = data.response.data.data

  // #34155，提示后需要跳转至指定页面
  if (getValue(menuParameter, 'param.isRouter')) {
    menuUtils.typeMethod.router(vue, menuParameter, data, null)
  }
}

/**
 * 购物车模型专用 : 返回数据更新到购物车 （按钮直接请求数据操作购物车）
 */
menuUtils.typeMethod.updateShoopingData = function (vue, menuParameter, data) {
  var that = vue.parentVue ? vue.parentVue : vue
  if (typeof that.reload == 'function') {
    that.updateShoopingData(data.response.data)
  } else {
    vue.updateShoopingData(data.response.data)
  }
}

/**
 * reload : 重新加载数据。
 */
menuUtils.typeMethod.reload = function (vue) {
  // 优先级1，在菜单父类方法获取
  if (vue.parentVue && typeof vue.parentVue.reload == 'function') {
    vue.parentVue.reload()
  } else {
    vue.reload()
  }
}

/**
 * innerTableReload : 编辑货详情页面，内部表格刷新方法
 */
menuUtils.typeMethod.innerTableReload = function (vue) {
  vue.reload()
}

/**
 * reloadDefer : 延迟重新加载数据。
 */
menuUtils.typeMethod.reloadDefer = function (vue) {
  setTimeout(() => {
    // 优先级1，在菜单父类方法获取
    if (vue.parentVue && typeof vue.parentVue.reload == 'function') {
      vue.parentVue.reload()
    } else {
      vue.reload()
    }
  }, 1000)
}

/**
 * closeCurrentTab : 关闭当前窗口。
 */
menuUtils.typeMethod.closeCurrentTab = function (vue) {
  // 在侧滑里面的时候抛出事件 fpr
  if (vue.onSide) {
    vue.$emit('side-item-dynamic-on-ok')
  } else {
    vue.$store.commit('closeCurrentTab', vue)
  }
}

/**
 * keepCurrentTab : 保留当前窗口。
 */
menuUtils.typeMethod.keepCurrentTab = function (vue) {
  if (vue.onSide) {
    vue.$emit('side-item-dynamic-on-ok-and-continue')
  }
}

/**
 * routerDefer : 延迟跳转
 */
menuUtils.typeMethod.routerDefer = function (vue, menuParameter, data) {
  setTimeout(() => {
    menuUtils.typeMethod.router(vue, menuParameter, data, null)
  }, 1000)
}

// 执行完成后，钩子动作定义
menuUtils.actionAfterOptions = [
  {
    value: 'closeCurrentTab',
    label: '关闭当前窗口',
  },
  {
    value: 'reload',
    label: '重新加载数据',
  },
  {
    value: 'router',
    label: '页面跳转',
  },
]

/**
 * checkData : 传入数据校验 购物车模型专用
 *
 */
menuUtils.typeMethod.checkData = function (vue, menuParameter, data) {
  return new Promise((resolve, reject) => {
    let param = menuParameter.param
    if (param) {
      const { rules, title, content } = param
      let isChecked = true,
        errMessage = [] // 是否验证通过
      if (Array.isArray(rules)) {
        rules.forEach((item) => {
          const result = templateUtil.compileData(item.check, data) // {"check":"{{验证表达式}}"}
          if (!result) {
            isChecked = false
            errMessage.push(item.message)
          }
        })
      } else if (typeof rules === 'object') {
        const checkR = templateUtil.compileData(rules.check, data) // {"check":"{{验证表达式}}"}
        if (!checkR) errMessage.push(rules.message)
        isChecked = checkR
      }
      if (!isChecked) {
        const con =
          errMessage.length > 0
            ? errMessage.map((im, i) => `${i + 1}、${im}`).join('；<br/>') + '；'
            : content || '确认继续？'
        const showCancelBtn = param.showCancelBtn !== undefined ? param.showCancelBtn : true
        vue.$pgMessage.confirm({
          title: title || '提示',
          content: con,
          sureBtnText: param.sureBtnText || '继续生单',
          showCancelBtn: showCancelBtn ?? true,
          cancelBtnText: param.cancelBtnText || '返回',
          onOk: () => {
            // 是否继续生单 true 就可以继续生单  false 就不能。#7549，增加解析模板
            const createNext = templateUtil.compileData(param.createNext, data)

            param.createNext = createNext !== undefined ? createNext : true
            param.createNext ? resolve(isChecked) : reject(isChecked)
          },
          cancel: () => {
            reject(isChecked)
          },
        })
      } else {
        resolve(isChecked)
      }
    } else {
      reject(null)
    }
  })
}
/**
 * triggerStore : 触发页面及 store 方法
 *
 */
menuUtils.typeMethod.triggerStore = (vue, menuParameter, data) => {
  return new Promise((resolve, reject) => {
    let param = templateUtil.compileData(menuParameter.param, data)
    let requestParam = templateUtil.compileData(menuParameter.requestParam, data)
    if (vue.store) {
      if (param.type === 'actions') {
        vue.store.dispatch(param.name, data, vue, requestParam)
        resolve(data)
      } else {
        vue.store.commit(param.name, data, vue, requestParam)
        resolve(data)
      }
    } else {
      reject(null)
    }
  })
}

/**
 * triggerStore : 触发页面及 store 方法(支持根据action判断是否可继续执行)
 *
 */
menuUtils.typeMethod.triggerPageStore = (vue, menuParameter, data) => {
  return new Promise((resolve, reject) => {
    let param = templateUtil.compileData(menuParameter.param, data)
    let requestParam = templateUtil.compileData(menuParameter.requestParam, data)
    if (vue.store) {
      if (param.type === 'actions') {
        vue.store
          .dispatch(param.name, data, vue, requestParam)
          .then((res) => {
            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        vue.store.commit(param.name, data, vue, requestParam)
        resolve(data)
      }
    } else {
      reject(null)
    }
  })
}
/***
 * 提示窗口方法
 */
menuUtils.typeMethod.confirmTip = function (vue, menuParameter, data) {
  let param = templateUtil.compileData(menuParameter.param, data)
  return menuUtils.special.ifConfirm(vue, param)
  // .then(right => {
  //   if(right === 'RIGHT'){

  //   }
  // }).catch(() => {
  //   reject(null)
  // })
}

/**
 * 自动打印
 * eg:
 * menuParameter.requestParam = {
    "url": "rest/main/store/inCheck/autoPrintLodopByOrderAndCommon",
    "printUrl": "rest/ezscc/scan/printLodop",
    "urlMethod": "post",
    "printMethod": "post",
    "urlParameters": {
      "ids": "{{data.items.map((elem)=>{return elem.id}).join()}}",
      "type": "INCLUDE_RFID",
      "catalog": "P3010"
    }
  }
 *
 */
menuUtils.typeMethod.printAuto = function (vue, menuParameter, data) {
  return new Promise((resolve, reject) => {
    const requestParam = templateUtil.compileData(menuParameter.requestParam, data)
    const url = requestParam.url
    const urlMethod = requestParam.urlMethod ?? 'post'
    const urlParameters = requestParam.urlParameters
    const printUrl = requestParam.printUrl
    const printMethod = requestParam.printMethod ?? 'post'

    // 获取自动打印数据
    vue.$axios[urlMethod](url, urlParameters).then((res) => {
      if (res.data.code === 200) {
        const printParam = res.data.data
        if (printParam) {
          const printParameters = Object.assign({}, requestParam.printParameters, res.data.data)
          // 将自动打印的数据传给【后置动作】处理，如: PgPrintImmediate
          vue.$axios[printMethod](printUrl, printParameters).then((res) => {
            if (res.data.code === 200) {
              resolve(res)
            } else {
              vue.$pgMessage.confirm({
                title: '提示',
                content: res.data.msg ?? '自动打印异常！',
              })
              reject(null)
            }
          })
        }
      } else {
        vue.$pgMessage.confirm({
          title: '提示',
          content: res.data.msg ?? '自动打印失败！',
        })
        reject(null)
      }
    })
  })
}

/**
 * 添加合并查询条件
 * eg. 报表管理 -采购报表-采购入库/采退出库统计表
 * 适用范围：页面组件选用 crudDoubleQuery 的页面
 */
menuUtils.typeMethod.addMergeQuerys = function (vue, menuParameter) {
  vue.parentVue.getData(null, { ...menuParameter.param })
}

export default menuUtils
